import { useContext } from 'react';
import { AppSettingsContext } from './context';
import { AppSettingsContextType } from './types';

export function useAppSettings(): AppSettingsContextType {
  const context = useContext(AppSettingsContext);
  if (context === undefined) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider');
  }
  return context;
}

export { type AppSettings } from './types';